import clsx from "clsx";
export default function Slider({
  cur,
  min,
  max,
  marks = 5,
  onChange,
  width = 96,
  disabled = false,
}: {
  cur: number;
  min: number;
  max: number;
  marks: number;
  onChange: (value: number) => void;
  height?: number;
  width?: number;
  disabled?: boolean;
}) {
  const step = (max - min) / (marks - 1);
  const stepWidth = width / marks;
  let curShowCounts;
  if (cur <= min) {
    curShowCounts = 1;
  } else if (cur >= max) {
    curShowCounts = marks;
  } else {
    if ((cur - min) % step === 0) {
      curShowCounts = (cur - min) / step + 1;
    } else curShowCounts = Math.ceil((cur - min) / step);
  }
  const curProgressWidth = curShowCounts * stepWidth || 0;
  //console.log("---lzc width", width, 'curShowCounts', curShowCounts, 'cur', cur, 'min', min, 'step', step,   'stepWidth', stepWidth);
  return (
    <div className={"flex items-center relative h-3"} style={{ width: width }}>
      <div className="h-1 rounded-sm bg-neutral-200 relative w-full overflow-hidden">
        <div
          className={clsx(
            "h-full",
            disabled ? "bg-transparent" : "bg-blue-500",
          )}
          style={{ width: curProgressWidth, transition: "width 300ms linear" }}
        ></div>
        {Array.from({ length: marks - 1 }).map((_, index) => {
          return (
            <div
              key={index}
              className="absolute top-0 h-1 w-px bg-gray-100"
              style={{ left: (index + 1) * stepWidth }}
            ></div>
          );
        })}
      </div>
      <div
        className={clsx(
          "h-3 w-3 boder rounded-xl absolute top-0",
          disabled ? "bg-neutral-200" : "bg-blue-500",
        )}
        style={{ left: curProgressWidth - 6, transition: "left 300ms linear" }}
      ></div>
      {Array.from({ length: marks }).map((_, index) => {
        return (
          <div
            key={index}
            className={clsx(
              "absolute top-0 h-full bg-transport",
              disabled ? "cursor-not-allowed" : "cursor-pointer",
            )}
            style={{ left: index * stepWidth, width: stepWidth }}
            onClick={() => {
              if (!disabled) onChange(index * step + min);
              console.log("---new value", index * step);
            }}
          ></div>
        );
      })}
    </div>
  );
}
